import React, { Component } from 'react'
import { connect } from 'react-redux'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ChevronRight from '@mui/icons-material/ChevronRight'
import _ from 'lodash'
import classNames from 'classnames'

import ItensExpansionPanel from '../../util/ItensExpansionPanel'
import styles from './MenuFiltrosItemsRadioGroup.module.css'
import { atualizarFiltros, descartarFiltros } from '../../../actions/filtrosActions'
import {
  isFiltroSelecionadoMenuFiltros,
  isFiltroVisivel
} from '../../../controllers/itensController'
import { notifyGoogleAnalyticsEventTracking } from '../../../util/applicationContext'

const radioGroupDefaultOptions = {
  Todos: '',
  Sim: 'true',
  Não: 'false'
}

const FILTRAR_POR_ACTION = 'filtrarPorAction'

class MenuFiltrosItemsRadioGroup extends Component {
  handleRadioGroupChange(itemKey, value, callback) {
    if (callback) callback(value)
    const { descartarOutrosFiltrosSelecionadosMenuFiltros } = this.props
    if (descartarOutrosFiltrosSelecionadosMenuFiltros) {
      this.props.descartarFiltros(descartarOutrosFiltrosSelecionadosMenuFiltros)
    }
    const action = `${FILTRAR_POR_ACTION}-${itemKey}-${value}`
    notifyGoogleAnalyticsEventTracking(FILTRAR_POR_ACTION, action)
    this.props.atualizarFiltros({ [itemKey]: value })
  }

  render() {
    const {
      label,
      itemKey,
      expanded,
      noExpandIcon,
      radioGroupRow,
      defaultExpanded,
      filtros,
      radioGroupOptions,
      setMenuItemHandle,
      filtros: { visao: visaoId, [itemKey]: itemAtual }
    } = this.props
    const radioGroupOptionsValue = !radioGroupOptions ? radioGroupDefaultOptions : radioGroupOptions
    const selected = isFiltroSelecionadoMenuFiltros(filtros, itemKey)
    return isFiltroVisivel(visaoId, itemKey) ? (
      <Grid
        container
        data-tour={`menu-select-items-${label}`}
        className={classNames(styles.containerGrid, { [styles.containerGridSelected]: selected })}>
        <ItensExpansionPanel
          noExpandIcon={noExpandIcon}
          expanded={expanded}
          defaultExpanded={defaultExpanded}
          expandIcon={<ChevronRight style={{ color: '(0, 0, 0, 0.51)' }} />}
          expandedIcon={<ExpandMore style={{ color: '(0, 0, 0, 0.51)' }} />}
          noBadge
          numItensVisiveis={1}
          itensComponents={[]
            .concat(
              <Grid item xs={12} key={`title-${label}`}>
                <Typography
                  variant='body2'
                  color='primary'
                  className={classNames({ [styles.containerGridSelectedTitle]: selected })}>
                  {label}
                </Typography>
              </Grid>
            )
            .concat(
              <Grid item xs={12} style={{ marginTop: 8 }} key={`content-${label}`}>
                <FormControl component='fieldset'>
                  <RadioGroup
                    row={radioGroupRow || false}
                    aria-label={label}
                    value={_.toString(itemAtual)}
                    onChange={(event) =>
                      this.handleRadioGroupChange(itemKey, event.target.value, setMenuItemHandle)
                    }>
                    {_.map(_.entries(radioGroupOptionsValue), (entry) => (
                      <FormControlLabel
                        key={_.uniqueId('option-')}
                        value={entry[1]}
                        classes={{ label: styles.label }}
                        control={<Radio color='secondary' classes={{ checked: styles.checked }} />}
                        label={entry[0]}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
            )}
          IconButtonProps={{
            className: styles.iconButton,
            styles: { root: styles.iconButtonRoot, edgeEnd: styles.edgeEnd }
          }}
        />
      </Grid>
    ) : null
  }
}

const mapStateToProps = ({ filtros }) => ({ filtros })

export default connect(mapStateToProps, { atualizarFiltros, descartarFiltros })(
  MenuFiltrosItemsRadioGroup
)
